export default function PreLoader({ active }) {
    return (
        <>
            <div id="page-preloader" className={active ? "is-active" : "is-hidden"}>
                <div className="preloader-1">
                    <div className="loader-text">Loading</div>
                    <span className="line line-1"></span>
                    <span className="line line-2"></span>
                    <span className="line line-3"></span>
                    <span className="line line-4"></span>
                    <span className="line line-5"></span>
                    <span className="line line-6"></span>
                    <span className="line line-7"></span>
                    <span className="line line-8"></span>
                    <span className="line line-9"></span>
                </div>
            </div>
        </>
    );
}
